/**
 * UserSelect.js
 * Farm2's select dialog via AIR to encourage zdc over fb.
 * Supports click and auto redirects to appropriate bias
 * @author Jaiwardhan Swarnakar
 */
import React from 'react';
import BaseComponent from '../../../../BaseComponent'
import './UserSelect.css'
import { Redirect } from "react-router-dom";
import ServiceLocator from '../../../../../ServiceLocator';
import DataStore from '../../../../../data/DataStore';
import Loading from '../../../../routing/Loading';
import ZyngaButton from '../../../../minions/buttons/ZyngaButton';
import FacebookButton from '../../../../minions/buttons/FacebookButton';
import $ from 'jquery'
import LocUtils from '../../../../../util/localization/LocUtils';
import SiteConstants from "../../../../../util/SiteConstants";

class UserSelect extends BaseComponent {
    constructor(props) {
        super(props)

        // Parse the query params and keep it ready
        this.params = ServiceLocator.NetworkManager.Utils.ParseQueryParameters()
        // Get appropriate game being required - eg. feature apps
        let game = (this.params["game"] !== undefined && String(this.params["game"]) !== "")
            ? String(this.params["game"]).toLowerCase()
            : "farmville-two"
        // Reconstruct data from LS
        this.redirectData = DataStore.LocalStorage.Get("ZDC_RDR_SESS");
        this.redirectData = (!!this.redirectData) ? this.redirectData : '{ "FB_CLK": 0, "FB_REM_SESS_WAIT": 0 }'
        try {
            this.redirectData = JSON.parse(this.redirectData)
            this.redirectData["FB_CLK"] = (!!this.redirectData["FB_CLK"]) ? this.redirectData["FB_CLK"] : 0
            this.redirectData["FB_REM_SESS_WAIT"] = (!!this.redirectData["FB_REM_SESS_WAIT"])
                ? this.redirectData["FB_REM_SESS_WAIT"] : 0
        } catch (error) {
            this.redirectData = { "FB_CLK": 0, "FB_REM_SESS_WAIT": 0 }
        }
        console.log("Redirection: AIR LAUCHER MASTER EXP: "+ this.params["zrmas"] !== undefined? this.params["zrmas"]: "UDEFINED");

        // Fetch game href from Env map
        this.href = ServiceLocator.Env.GameMaps.Get("Farm2", game).href
        this.state = {
            l: (this.params["l"] !== undefined || String(this.params["l"]) !== "") ? this.params["l"] : "",
            ts: (this.params["ts"] !== undefined || String(this.params["ts"]) !== "") ? this.params["ts"] : "",
            zid: (this.params["zid"] !== undefined || String(this.params["zid"]) !== "") ? this.params["zid"] : "",
            game: game,
            ready: false,
            redirect: false,
            masterExp: this.params["zrM"] !== undefined? parseInt(this.params["zrM"]): 0,
            zdcCountExp:this.params["zrL"] !== undefined? parseInt(this.params["zrL"]): 0,
            fbCountExp:this.params["zrD"] !== undefined? parseInt(this.params["zrD"]): 0,
            resurfaceExp:this.params["zrR"] !== undefined? parseInt(this.params["zrR"]): 0,
            fbButtonExp:this.params["zrB"] !== undefined? parseInt(this.params["zrB"]): 0,
            farmBucksExp:this.params["zrF"] !== undefined? parseInt(this.params["zrF"]): 0,
            zdcChoice:this.params["zrC"] !== undefined? parseInt(this.params["zrC"]): 0
        }

        // Bindings
        this.computeBias = this.computeBias.bind(this)
        this.goZDC = this.goZDC.bind(this)
        this.goFB = this.goFB.bind(this)
        this.goDialog = this.goDialog.bind(this)
        this.fallback = this.fallback.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.pruneParams = this.pruneParams.bind(this)
        this.onClickZynga = this.onClickZynga.bind(this)
        this.onClickFb = this.onClickFb.bind(this)
        this.getEOSExperiments = this.getEOSExperiments.bind(this)
        this.fetchInfo  = this.fetchInfo.bind(this)
    }

    /**
     * Attempts to get load the EOS experiments of this user.
     * Requires a session
     */
    getEOSExperiments() {
        //var _selfSig = "eosLoad";
        super.log("Fetching Lab Sauce!");
        ServiceLocator.OptimizationManager.EOS.Init((status) => {
            //this.loginSync(_selfSig, true);
            this.initRedirectionData(status);
            // In case EOS didn't load
            // throw an error log.
            if (status === false) {
                //super.fatal("EOS Load: Failed to load EOS on login.");
                console.log("Redirection getEOSExperiments status=false");
            }
        }, true);
        //this.initRedirectionData(false);
    }

    closeModal() {
        $("#airZDCSelect").modal('hide');
    }

    /**
     * Computes the bias based on session data
     * @param {Int} reminder_cap The threshold for bias to be favorable
     * @param {Int} fbCount The reminder cap for fb platform
     */
    computeBias( reminder_cap, fbCount) {
        let minLen = parseInt(process.env.REACT_APP_ZDC_RDR_TS_MIN_LEN)
        /*if(this.state.zdcCountExp === 2 ) {
            minLen = 14;
        }*/
        var totLen = String(this.state.ts).length
        if (totLen >= minLen) {
            if(this.state.zdcCountExp === 1) {
                totLen = Math.min(totLen, 10);
            }
            else if(this.state.zdcCountExp === 2) {
                totLen = Math.min(totLen, 14);
            }
            let zo = 0
            for (let i = String(this.state.ts).length-1 ; i > String(this.state.ts).length - totLen -1 ; i--) {
                if (String(this.state.ts).charAt(i) === String(process.env.REACT_APP_ZDC_RDR_FAV_CHAR)) {
                    zo++;
                }
            }

            //let biasPc = parseInt(Math.ceil((zo / totLen) * 100))
            if (zo >= 7 ) {
                console.log("REDIRECTION: Bias exceeded . Redirect to ZDC");
                // Sufficient zdc bias
                ServiceLocator.ZTrack.Cast({
                    counter: "air_rdr",
                    kingdom: "auto",
                    phylum: "zdc",
                    genus: "bias",
                    family: String(2)
                })
                this.goZDC()
            }
        }
        if(this.state.zdcChoice === 2)  {
            console.log("REDIRECTION: ZDC choice is 2. Go dialog");
            this.goDialog();
            return;
        }
        // Check if we are in cooldown
        if ((this.redirectData["FB_REM_SESS_WAIT"] > 0 &&
            this.redirectData["FB_REM_SESS_WAIT"] < reminder_cap) ||
            this.redirectData["FB_CLK"] >= fbCount) {
            // Continue fb
            this.redirectData["FB_CLK"] = 0
            this.redirectData["FB_REM_SESS_WAIT"] += 1
            DataStore.LocalStorage.Store("ZDC_RDR_SESS", JSON.stringify(this.redirectData))
            ServiceLocator.ZTrack.Cast({
                counter: "air_rdr",
                kingdom: "auto",
                phylum: "fb",
                genus: "cooldown",
                family: "ses-" + String(this.redirectData["FB_REM_SESS_WAIT"])
            })
            console.log("REDIRECTION: In cooldown . GO FB");
            this.goFB()
            return
        } else {
            // reset the rem sess to 0
            this.redirectData["FB_REM_SESS_WAIT"] = 0;
            DataStore.LocalStorage.Store("ZDC_RDR_SESS", JSON.stringify(this.redirectData));
            console.log("REDIRECTION: Resurface Dialog after cooldown. Go Dialog");
            this.goDialog();
        }
    }

    /**
     * Prune redundant params to carry over
     */
    pruneParams() {
        let l = JSON.parse(JSON.stringify(this.params));
        delete l["ts"]
        delete l["l"]
        delete l["game"]
        l["rdr_source"] = "zdc"
        return ServiceLocator.NetworkManager.Utils.GetURLEncoded(l)
    }

    goZDC() {
        delete this.params["ts"]
        delete this.params["l"]
        delete this.params["game"]
        this.params["rdr_source"] = "zdc"

        this.redirectData["FB_CLK"] = 0;
        this.redirectData["FB_REM_SESS_WAIT"] = 0;
        DataStore.LocalStorage.Store("ZDC_RDR_SESS", JSON.stringify(this.redirectData))

        this.setState({
            redirect: true,
            ready: true
        })
    }

    goFB(clicked = false) {
        delete this.params["ts"]
        delete this.params["l"]
        delete this.params["game"]
        this.params["rdr_source"] = "zdc"

        if (!!clicked) {
            this.redirectData["FB_CLK"] += 1;
            DataStore.LocalStorage.Store("ZDC_RDR_SESS", JSON.stringify(this.redirectData))
        }
        let updatedSearchParams = ServiceLocator.NetworkManager.Utils.GetURLEncoded(this.params)
        this.href = ServiceLocator.Env.Platforms.Get().url +
            "/" + this.state.game +
            (String(updatedSearchParams).length > 0 ? "?" + updatedSearchParams : "")
        window.location.href = this.href
    }

    goDialog(reason = "", condition = "") {
        ServiceLocator.ZTrack.Cast({
            counter: "air_rdr",
            kingdom: "dialog",
            phylum: String(reason),
            genus: String(condition)
        })
        this.setState({
            ready: true,
            redirect: false
        })

        // Back & forth in logged out mode needs to be handled
        $("#loginModalCenter").modal('hide');
        $("#loginModalCenter").trigger('reset');
        setTimeout(() => {
            $("#airZDCSelect").modal('show');
        }, 500)
        setTimeout(() => {
            $("#loginModalCenter").modal('hide');
        })
    }

    /**
     * Fallback to last resort
     * @param {String} reason Why do you want to fallback?
     */
    fallback(reason = "") {
        if (this.state.l === "" || this.state.l.toLocaleLowerCase() === "zdc") {
            ServiceLocator.ZTrack.Cast({
                counter: "air_rdr",
                kingdom: "fallback",
                phylum: "zdc",
                genus: String(reason)
            })
            this.goZDC()
        } else if (this.state.l === "fb") {
            ServiceLocator.ZTrack.Cast({
                counter: "air_rdr",
                kingdom: "fallback",
                phylum: "fb",
                genus: String(reason)
            })
            this.goFB()
        } else {
            ServiceLocator.ZTrack.Cast({
                counter: "air_rdr",
                kingdom: "fallback",
                phylum: "dialog",
                genus: String(reason)
            })
            this.goDialog("fallback")
        }
    }

    /** Fetch backend data related to redirection feature */
    initRedirectionData(status = false) {

        if(status  === true) {
            var variant = ServiceLocator.OptimizationManager.EOS.GetExperimentVariant(SiteConstants.RedirectionExperiments.MASTER_EXPERIMENT);
            console.log("Redirection : Master variant  is"+variant);
            this.setState({
                masterExp: variant
            })
            variant = ServiceLocator.OptimizationManager.EOS.GetExperimentVariant(SiteConstants.RedirectionExperiments.ZDC_COUNT_EXPERIMENT);
            console.log("Redirection : ZDC COUNT variant  is"+variant);
            this.setState({
                zdcCountExp: variant
            })
            variant = ServiceLocator.OptimizationManager.EOS.GetExperimentVariant(SiteConstants.RedirectionExperiments.FB_CHOOSE_COUNT_EXPERIMENT);
            console.log("Redirection : FB CHOOSE COUNT variant  is"+variant);
            this.setState({
                fbCountExp: variant
            })

            variant = ServiceLocator.OptimizationManager.EOS.GetExperimentVariant(SiteConstants.RedirectionExperiments.SELECT_RESURFACE_EXPERIMENT);
            console.log("Redirection : SELECT RESURFACE variant  is"+variant);
            this.setState({
                resurfaceExp: variant
            })
            variant = ServiceLocator.OptimizationManager.EOS.GetExperimentVariant(SiteConstants.RedirectionExperiments.FB_BUTTON_EXPERIMENT);
            console.log("Redirection : FB BUTTON variant  is"+variant);
            this.setState({
                fbButtonExp: variant
            })
            variant = ServiceLocator.OptimizationManager.EOS.GetExperimentVariant(SiteConstants.RedirectionExperiments.FARM_BUCKS_EXPERIMENT);
            console.log("Redirection : FARM BUCK variant  is"+variant);
            this.setState({
                farmBucksExp: variant
            })
            variant = ServiceLocator.OptimizationManager.EOS.GetExperimentVariant(SiteConstants.RedirectionExperiments.ZDC_CHOICE_EXPERIMENT);
            console.log("Redirection : ZDC CHOICE variant  is"+variant);
            this.setState({
                zdcChoice: variant
            })
        }
        else {
            console.log("Redirection: EOS failed. Using URL params for experiments");
            console.log("Redirection : Master variant  is"+this.state.masterExp);

            console.log("Redirection : ZDC COUNT variant  is"+this.state.zdcCountExp);

            console.log("Redirection : FB CHOOSE COUNT variant  is"+this.state.fbCountExp);

            console.log("Redirection : SELECT RESURFACE variant  is"+this.state.resurfaceExp);

            console.log("Redirection : FB BUTTON variant  is"+this.state.fbButtonExp);

            console.log("Redirection : FARM BUCK variant  is"+this.state.farmBucksExp);

            console.log("Redirection : ZDC CHOICE variant  is"+this.state.zdcChoice);

        }

        console.log("Redirection: Session CSRF"+ServiceLocator.SocialNetworkManager.SessionData().csrf);
        console.log("Redirection: Session ZID"+ServiceLocator.SocialNetworkManager.SessionData().zid);


        this.fetchInfo();
    }

    componentDidMount() {

        console.log("Redirection componentDidMount entered");

        this.getEOSExperiments()



    }

    fetchInfo() {
        console.log("REDIRECTION: FB_REM_SESS_WAIT "+ this.redirectData["FB_REM_SESS_WAIT"]+ " FB_CLK "+this.redirectData["FB_CLK"]);

        if (this.state.zdcChoice === 3) {
            console.log("Redirection fetchInfo zdcChoice=3 going to zdc");
            this.goZDC()
        } else if (this.state.masterExp !== 2) {
            console.log("Redirection fetchInfo masterExp=0");
            if (!this.state.l || this.state.l.toLocaleLowerCase() === "zdc")  {
                console.log("Redirection fetchInfo masExp=0 going to zdc");

                this.goZDC()
            }
            else if(this.state.l.toLocaleLowerCase() === "fb"){
                console.log("Redirection fetchIfo masExp=0 going to fb");

                this.goFB()
            }
            else {
                console.log("Redirection fetchInfo masExp=0 going to dialog");
                this.goDialog()
            }

        }
        else {
            console.log("Redirection componentDidMount masterExp =2");
            if(!this.state.l) {
                console.log("Redirection componentDidMountbegining  going to dialog");
                this.goDialog();
            }
            else if (this.state.l.toLocaleLowerCase() === "zdc")  {
                console.log("Redirection componentDidMount going to zdc");

                this.goZDC()
            }
            ServiceLocator.ZTrack.Cast({
                counter: "air_rdr",
                kingdom: "page-load"
            })
            // If no last data is present (possible new install) or
            // last session was zdc, directly go to zdc Farm2
            var params = {
                request: "info",
            }
            ServiceLocator.NetworkManager.Fetch.Call({
                url: process.env.REACT_APP_AUTH_ISSUETOKEN + "/ajax/common_web:zauth_airZDCRedirect",
                payload: {
                    method: 'POST',
                    body: ServiceLocator.NetworkManager.Utils.GetURLEncoded(params),
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    referrer: 'client'
                },
                token: "AIR_RDR_FETCH_INFO"
            }).then(resp => resp.json())
                .then(resp => {
                    console.log("REDIRECTION: RESPAIRREDIRECT "+JSON.stringify(resp));
                    console.log("REDIRECTION: SUCCESS "+resp["success"]+" E: "+resp["e"]);
                    if (resp["success"] !== undefined && String(resp["success"]) === "true") {
                        console.log("Redirection: Server ZID"+resp["zid"]);
                        console.log("Redirection: Server Data"+resp.toString());
                        if (String(resp["e"]) === "1") {
                            var cap = 50;
                            if(this.state.resurfaceExp === 2) {
                                cap = 75;
                            }
                            else if(this.state.resurfaceExp === 3) {
                                cap = 100;
                            }

                            var fbCount = resp["pc"] !== undefined ? resp["pc"] : 3;
                            if(this.state.fbCountExp === 2 ) {
                                fbCount = fbCount + 2;
                            }
                            else if(this.state.fbCountExp  === 3) {
                                fbCount = fbCount + 4;
                            }
                            console.log("REDIRECTION: CAP "+ cap + " FBCOUNT: "+fbCount);
                            this.computeBias(
                                cap, fbCount)
                        } else {

                            console.log("REDIRECTION: FALLBACK-DISABLED");
                            // Disabled, impl fallback
                            this.fallback("disabled")
                        }
                    } else {
                        console.log("REDIRECTION: FALLBACK-ERROR_BE");
                        // Backend err
                        this.fallback("error-be")
                    }
                })
                .catch(err => {
                    // Backend err
                    console.log("REDIRECTION: FALLBACK-ERROR_FETCH");
                    this.fallback("error-fetch")
                })

        }


    }

    /* Click sources */
    onClickZynga() {
        ServiceLocator.ZTrack.Cast({
            counter: "air_rdr",
            kingdom: "go",
            phylum: "click",
            genus: "zdc"
        })
        this.closeModal();
        this.goZDC();
    }

    onClickFb() {
        ServiceLocator.ZTrack.Cast({
            counter: "air_rdr",
            kingdom: "go",
            phylum: "click",
            genus: "fb"
        })
        this.closeModal();
        this.goFB(true);
    }

    render() {
        return (
            <div>
                {!this.state.ready && (<Loading />)}
                {this.state.ready && this.state.redirect &&
                    <Redirect to={this.href + "?" + this.pruneParams()} />
                }
                {this.state.ready && !this.state.redirect &&
                    <div id="user-select-page">
                        <img className="bg-image"
                            src={process.env.REACT_APP_ASSET_PATH + "/pages/landing/fv2_banner.jpg"} alt="Farmville 2" />
                        <div className="modal fade" id="airZDCSelect" data-backdrop="static" data-keyboard="false" tabIndex="1" role="dialog" aria-labelledby="airZDCSelect" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                <div className="modal-content" style={{ border: "none" }}>
                                    <div className="modal-body modal-body-mod">
                                        <div className="bg-text">
                                            <div className="row no-gutters" style={{ backgroundColor: "#222C37" }}>
                                                <div className="col " style={{ alignItems: "center", display: "flex" }}>
                                                    <img alt="zynga" className="header-zy-logo"
                                                        src={process.env.REACT_APP_ASSET_PATH + "/zynga-logo-off.png"} />
                                                    <div className="rdr-header-text">{LocUtils.T("pages.games.farm2.air_select.header")}</div>
                                                </div>
                                            </div>
                                            <div className="row bottom-messaging">
                                                <div className="col-1"></div>
                                                <div className="col" style={{ lineHeight: "1.4rem" }}>
                                                    <span className="rdr-bottom-text align-middle">{LocUtils.T("pages.games.farm2.air_select.desc")}</span>
                                                </div>
                                                <div className="col-1"></div>
                                            </div>
                                            <div className="row no-gutters">
                                                <div className="col">
                                                    <img alt="airZDCBenefits"
                                                        src={process.env.REACT_APP_ASSET_PATH + "/games/farm2/air/zdcredirectione_selectiondialogvip_motd_zdc_html_page.png"} style={{ width: "100%" }} />
                                                </div>
                                            </div>
                                            <div className="row no-gutters select-button-container">
                                                <div className="col-1 col-xs-3 col-sm-1 col-md-3"></div>
                                                <div className="col-10 col-xs-6 col-sm-10 col-md-6">
                                                    <ZyngaButton type="link" to={this.href + "?" + this.pruneParams()}
                                                        message={LocUtils.T("pages.games.farm2.air_select.bt_zy_play")}
                                                        extraClass="animation-glowing-zy"
                                                        onClick={this.onClickZynga} />
                                                </div>
                                                <div className="col-1 col-xs-3 col-sm-1 col-md-3"></div>
                                            </div>
                                            {this.state.zdcChoice !== 2 && this.state.fbButtonExp === 2 &&  <div className="decide-button">
                                                <div className="row bottom-messaging">
                                                    {/* Show fb button and footer on lg and larger devices */}
                                                    <div className=" d-none d-xs-none col-xs-0 d-sm-none col-sm-0 d-md-none col-md-0 d-lg-block col-lg-12 d-xl-block col-lg-12"
                                                         style={{ lineHeight: "1.6rem" }}>
                                                        <span className="rdr-bottom-text text-center">{LocUtils.T("pages.games.farm2.air_select.footer")}</span>
                                                        <FacebookButton
                                                            type="round"
                                                            message={LocUtils.T("pages.games.farm2.air_select.bt_fb_play")}
                                                            onClick={this.onClickFb} />
                                                    </div>
                                                    {/* Show only footer on lower than md devices */}
                                                    <div className=" d-block d-xs-block col-xs-12 d-sm-block col-sm-12 d-md-block col-md-12 d-lg-none col-lg-0 d-xl-none col-xl-0"
                                                         style={{ lineHeight: "1.6rem" }}>
                                                        <span className="rdr-bottom-text text-center">{LocUtils.T("pages.games.farm2.air_select.footer")}</span>
                                                    </div>
                                                </div>

                                            </div>}
                                            {this.state.zdcChoice !==2 && this.state.fbButtonExp !== 2 && <div className="decide_button_center">
                                                <div className="row bottom-messaging">
                                                    <div className=" d-none d-xs-none col-xs-0 d-sm-none col-sm-0 d-md-none col-md-0 d-lg-block col-lg-12 d-xl-block col-lg-12"
                                                         style={{ lineHeight: "1.6rem" , marginBottom: "1rem" }}>
                                                        <span className="rdr-bottom-text text-center">{LocUtils.T("pages.games.farm2.air_select.footer")}</span>
                                                    </div>
                                                    {/* Show fb button on the last row on lower than md devices */}
                                                    <div className="d-none d-xs-none col-xs-0 d-sm-none col-sm-0 d-md-none col-md-0 d-lg-block col-lg-12 d-xl-block col-lg-12"
                                                         style={{ lineHeight: "1.6rem" }}>
                                                        <FacebookButton
                                                            type="round"
                                                            message={LocUtils.T("pages.games.farm2.air_select.bt_fb_play")}
                                                            onClick={this.onClickFb} />
                                                    </div>
                                                </div>

                                            </div>}


                                            <div className="row bottom-footer">
                                                <div className="col">
                                                    <img alt="zynga" className="footer-farm"
                                                        src={process.env.REACT_APP_ASSET_PATH + "/games/farm2/air/footer.png"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default UserSelect